export const SET_WEBSITE_PROPERTY = 'SET_WEBSITE_PROPERTY';
export const GET_WEBSITE_HOME_PAGE_DATA = 'GET_WEBSITE_HOME_PAGE_DATA';
export const GET_WEBSITE_CONTACT_PAGE_DATA = 'GET_WEBSITE_CONTACT_PAGE_DATA';
export const GET_WEBSITE_LEGAL_DATA = 'GET_WEBSITE_LEGAL_DATA';
export const GET_APP_COMMON_DATA = 'GET_APP_COMMON_DATA';
export const CREATE_GET_IN_TOUCH = 'CREATE_GET_IN_TOUCH';
export const GET_WEBSITE_PROJECTS_PAGE_DATA = 'GET_WEBSITE_PROJECTS_PAGE_DATA';
export const GET_WEBSITE_OUR_COMPANY_PAGE_DATA = 'GET_WEBSITE_OUR_COMPANY_PAGE_DATA';
export const GET_WEBSITE_WHAT_WE_DO_PAGE_DATA = 'GET_WEBSITE_WHAT_WE_DO_PAGE_DATA';
export const GET_CATEGORIES_DATA = 'GET_CATEGORIES_DATA';
export const GET_PROJECTS_SUMMARY_DATA = 'GET_PROJECTS_SUMMARY_DATA';
export const GET_PROJECT_BY_SLUG_DATA = 'GET_PROJECT_BY_SLUG_DATA';
export const GET_PROJECTS_FOR_HOME_DATA = 'GET_PROJECTS_FOR_HOME_DATA';
export const GET_REVIEWS_DATA = 'GET_REVIEWS_DATA';
export const GET_EMPLOYEES_DATA = 'GET_EMPLOYEES_DATA';
